// extracted by mini-css-extract-plugin
export default {"containerTimer":"Timer_containerTimer__lnIku"};